// extracted by mini-css-extract-plugin
export default {"contentRow":"styles_contentRow__aq7Ed","headerRow":"styles_headerRow__qLWx8","item1":"styles_item1__LMMVH","item2":"styles_item2__rGV5a"};